import { useMemo } from 'react';
import { SORT_MAP } from '../utils/sorting';

const useTableSort = ({ data = [], columns, sortBy, sortDirection }) =>
  useMemo(() => {
    if (!sortBy) {
      return data;
    }

    const column = columns.find(({ dataKey }) => dataKey === sortBy);

    const { format: sortType, sortFunc } = column || {};

    const sorter = sortFunc || SORT_MAP?.[sortType]?.(sortBy);

    return data.sort((a, b) => (sortDirection === 'asc' ? sorter?.(a, b) : sorter?.(b, a))).slice();
  }, [columns, data, sortBy, sortDirection]);

export default useTableSort;
